import Component from '../core/Component';
import $ from 'jquery';
import enquire from 'enquire.js';
import { queries } from '../core/config';
import loadTouchEvents from 'jquery-touch-events';
loadTouchEvents($);

export default class Carousel extends Component
{
    constructor($element)
    {
        super($element);
        this.carouselItems = $element.find('[data-carousel-item]');
        this.carouselControlItems = $element.find('[data-carousel-control-item]');
        this.carouselArrows = $element.find('[data-carousel-arrow]');
        this.loop = null;
        this.timeout = null;
        this.index = 0;
        this.time = 5000;

        this.max = this.carouselItems.length;
    }

    prepare()
    {
        var self = this;
        this.carouselItems.eq(0).addClass('active');
        this.carouselControlItems.eq(0).addClass('active');
        this.createLoop();

        enquire.register(queries.smallMax, {
            match: () => {

                self.carouselControlItems.find('a').on('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                });
                self.carouselControlItems.on('click', function (event) {
                    event.preventDefault();
                    var $item = $(this);
                    self.index = $item.index();
                    self.carouselControlItems.removeClass('fix');
                    $item.addClass('fix');
                    self.makeActive($item.index());
                    clearInterval(self.loop);
                    clearInterval(self.timeout);

                    self.timeout = setTimeout(function () {
                        self.next();
                        self.createLoop();
                        $item.removeClass('fix');
                    }, 8000);
                });
            }
        });

        this.carouselArrows.on('click', function () {
            self.carouselControlItems.removeClass('fix');
            if ($(this).data('carousel-arrow') == 'prev') {
                self.prev();
            } else if ($(this).data('carousel-arrow') == 'next') {
                self.next();
            }
            self.createLoop();
        });

        enquire.register(queries.mediumMax, {
            match: () => {
                this.$element.on('swipeleft', event => {
                    self.next();
                    self.createLoop();
                });
                this.$element.on('swiperight', event => {
                    self.prev();
                    self.createLoop();
                });
            }
        });
    }

    createLoop () {
        clearInterval(this.loop);
        this.loop = setInterval(() => {
            this.next();
        }, this.time);
    }

    next() {
        this.index++;

        if (this.index == this.max) {
            this.index = 0;
        }

        this.makeActive(this.index);
    }

    prev() {
        this.index--;

        if (this.index < 0) {
            this.index = this.max-1;
        }

        this.makeActive(this.index);
    }

    eraseActiveClasses () {
        this.carouselItems.removeClass('active');
        this.carouselControlItems.removeClass('active');
    }

    makeActive (index) {
        var i = parseInt(index || this.index);
        this.eraseActiveClasses();
        this.carouselItems.eq(i).addClass('active');
        this.carouselControlItems.eq(i).addClass('active');
    }
}


// WEBPACK FOOTER //
// ./components/Carousel.js